import { createClient } from '@supabase/supabase-js';
import type { Database } from '@yucanvas/shared';
import { env } from './env';

// Session persistence matters more here than anywhere else in the app: a
// reauth prompt on a street with no bars ends a shift (PLAN 6).
export const supabase = createClient<Database>(
  env.supabaseUrl || 'http://localhost:54321',
  env.supabaseAnonKey || 'anon-key-missing',
  {
    auth: {
      persistSession: true,
      autoRefreshToken: true,
      detectSessionInUrl: false,
      storageKey: 'yucanvas.auth',
    },
  },
);
